// extracted by mini-css-extract-plugin
export default {"h":"style_h__pRNIW","hMobile":"style_hMobile__k8MjW"};